import http from '../../utils/fetch';
export default {

    baseurl:'/api/swyl/v1/formulanew/rateFormulaRenew',

    pro:'/api/swyl/v1/xiangmu/proProductInfo',

    allvw:'/api/swyl/v1/allmaterialvw/viewMaterialAllvw',

    guocheng:'/api/swyl/v1/renewver/rateFormulaRenewVer',

    dingjiabiao:'/api/swyl/v1/price/mdmMaterialInfoPrice',

    chanpinbiao:'/api/swyl/v1/material/manager/Material',

    //通过项目id获取翻页物料
    haiwaixiangmuwuliaoPage(query){
        return http({
            url: this.baseurl+'/haiwaixiangmuwuliaoPage',
            method: 'post',
            params: query
        });
    },


    //海外项目测算
    getbyhaiwaixiangmu(entity){
        return http.post(this.baseurl+'/getbyhaiwaixiangmu',entity);
    },

    //海外项目测算
    getbyformulahaiwai(entity){
        return http.post(this.baseurl+'/getbyformulahaiwai',entity);
    },

    //逻辑删除版本
    luojishanchubanben(query){
        return http({
            url: this.baseurl+'/luojishanchu',
            method: 'post',
            params: query
        });
    },

    //逻辑删除版本
    luojishanchubanbenNx(query){
        return http({
            url: this.baseurl+'/luojishanchuNx',
            method: 'post',
            params: query
        });
    },


    //获取定价
    huoqudingjia(query){
        return http({
            url: this.dingjiabiao+'/huoqudingjia',
            method: 'post',
            params: query
        });
    },

    //获取所有物料号:物料描述
    getMarcodeAll(){
        return http({
            url: this.chanpinbiao+'/getMarcodeAll',
            method: 'post'
        });
    },


    //获取 物料: (w21 w25 u31):值
    chazhaosunyi(wuliaoji){
        return http.post(this.baseurl+'/chazhaosunyi',wuliaoji);
    },

    //获取 物料: (w21 w25 u31):值
    chazhaosunyiLk(wuliaoji){
        return http.post(this.baseurl+'/chazhaosunyiLk',wuliaoji);
    },




}